module.exports = __webpack_public_path__ + "static/media/JO.575f2622.svg";